import { Link } from "react-router-dom";
import { NAV_ITEMS, SOCIALS } from "@/data/content";
import { LogoMark, SocialIcon } from "@/components/Icons";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-cream grain relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <LogoMark size={40} />
              <div>
                <p className="font-serif text-2xl font-semibold">Laure Hila</p>
                <p className="text-[11px] uppercase tracking-[0.28em] text-cream/60">
                  Viaggia in Grande
                </p>
              </div>
            </div>
            <p className="mt-6 font-serif text-xl md:text-2xl italic text-gold">
              Viaggi • Cambiamento • Libertà
            </p>
            <p className="mt-4 text-sm text-cream/60 leading-relaxed max-w-sm">
              Una storia autentica di cambiamento, viaggi e nuovi inizi.
              Dalla provincia di Bergamo verso il mondo.
            </p>
            <div className="flex items-center gap-4 mt-7">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${s.name} di Laure Hila`}
                  data-testid={`footer-social-${s.icon}`}
                  className="w-10 h-10 rounded-full border border-cream/20 flex items-center justify-center text-cream/70 hover:text-gold hover:border-gold transition-colors duration-300"
                >
                  <SocialIcon icon={s.icon} size={17} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-[0.22em] text-cream/50 font-semibold mb-5">
              Navigazione
            </p>
            <nav className="grid grid-cols-1 gap-2.5" aria-label="Navigazione footer">
              {NAV_ITEMS.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`footer-nav-${item.path.replace(/\//g, "") || "home"}-link`}
                  className="text-sm text-cream/75 hover:text-gold transition-colors duration-300 w-fit link-underline"
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-cream/50 font-semibold mb-5">
              Legale
            </p>
            <div className="flex flex-col gap-2.5">
              <Link
                to="/privacy-policy"
                data-testid="footer-privacy-link"
                className="text-sm text-cream/75 hover:text-gold transition-colors duration-300 w-fit link-underline"
              >
                Privacy Policy
              </Link>
              <Link
                to="/cookie-policy"
                data-testid="footer-cookie-link"
                className="text-sm text-cream/75 hover:text-gold transition-colors duration-300 w-fit link-underline"
              >
                Cookie Policy
              </Link>
            </div>
            <p className="mt-8 text-sm text-cream/50">Provincia di Bergamo, Italia</p>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-cream/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-cream/45">
            © {new Date().getFullYear()} Laure Hila — Viaggia in Grande. Tutti i diritti riservati.
          </p>
          <p className="text-xs text-cream/45 font-serif italic">
            Viaggi • Cambiamento • Libertà
          </p>
        </div>
      </div>
    </footer>
  );
}
